enum OverlayActions {
  Open,
  Close,
  Push,
  Pop,
}

export default OverlayActions;
